import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { NuevoClienteDocumentacionComponent, validar } from "./view";
type Entity = models.NuevoClienteDocumentacion;
export interface Params {
    contactoObligatorio: boolean;
}
export interface Props extends kea.ModalProps<Entity, boolean, Params> {
}

/**
* Modal de edición para un NuevoClienteDocumentacion
*/
export class NuevoClienteDocumentacionModal extends React.PureComponent<Props> {

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    contactoObligatorio = (x: Props) => x.params.contactoObligatorio;

    render() {
        const contactoObligatorio = this.contactoObligatorio(this.props);
        const hasError = validation.hasError(validar(this.props.value, contactoObligatorio));
        const value = this.props.value;
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Nuevo cliente"
            >
                <NuevoClienteDocumentacionComponent value={value} onChange={this.props.onChange} contactoObligatorio={contactoObligatorio} />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/nuevoclientedocumentacion/modal.tsx